Pluswerk.PlusProject.Image = {};

/**
 * FocusPointBlurController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Image.FocusPointBlurController = function () {
  var $imageLow = $('.js-focusPoint--low');
  var $imageHigh = $('.js-focusPoint--high img');
  var $imageWrapper = $('.js-headerImage');

  $imageLow.focusPoint();

  var initBlurEffect = function () {
    $imageHigh.attr('src', $imageHigh.data('imgsrc'));
    $imageHigh.imagesLoaded(function () {
      $(this.elements).each(function (i, image) {
        var $image = $(image);
        $image.parent().focusPoint();
      });
      $imageWrapper.addClass('headerImage--loaded');

      // timeout because of css animation
      if ($imageWrapper.hasClass('headerImage--width')) {
        $imageLow.remove();
      } else {
        setTimeout(function () {
          $imageLow.remove();
        }, 1000);
      }
    });
  };

  if ($imageLow.length) {
    initBlurEffect();
  } else if ($imageWrapper.find('.js-headerImage__video').length) {
    $imageWrapper.addClass('headerImage--loaded');
  }
};
